import { motion } from "framer-motion";
import { Quote } from "lucide-react";

const ITEMS = [
  {
    quote:
      "Redesenhamos toda a rotina fiscal em três meses. O time hoje resolve problemas com PowerApps e Python sem depender de fila de TI.",
    name: "Diretor Financeiro",
    role: "Indústria de bens de consumo · LATAM",
  },
  {
    quote:
      "A Ponzena trouxe uma visão sênior de ERP que faltava. Encontraram gargalos que estavam invisíveis por anos e mostraram como resolver.",
    name: "Gerente de PCP",
    role: "Manufatura · Brasil",
  },
  {
    quote:
      "Os workshops de IA mudaram a cabeça do time. Passamos a construir automação em dias, não meses — e com compliance.",
    name: "Head de TI",
    role: "Serviços B2B · SP",
  },
];

export default function Testimonials() {
  return (
    <section className="relative py-28 md:py-36 bg-[#050F26]/40" data-testid="testimonials-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="max-w-3xl mb-14">
          <p className="label-eyebrow">Quem já viu na prática</p>
          <h2 className="font-display text-4xl md:text-5xl lg:text-6xl mt-4 leading-tight tracking-tight text-white">
            <span className="gradient-text">Vozes</span> de quem viveu a transformação.
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-6" data-testid="testimonials-grid">
          {ITEMS.map((t, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.5, delay: i * 0.1 }}
              className="card-surface p-8 flex flex-col justify-between"
              data-testid={`testimonial-${i}`}
            >
              <div>
                <Quote size={32} className="text-cyan-400" />
                <p className="mt-6 text-[#D8DDE8] text-lg leading-relaxed">{t.quote}</p>
              </div>
              <div className="mt-8 pt-6 border-t border-cyan-400/15">
                <p className="font-display font-semibold text-white">{t.name}</p>
                <p className="text-xs text-cyan-400 font-mono-tech mt-1 tracking-widest uppercase">
                  {t.role}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
